import validate from 'validate.js';

export const getPhoneCodeByCountry = (countryCode?: string): string => {
  switch (countryCode) {
    case 'DE':
      return '+49';
    case 'NL':
      return '+31';
    case 'BE':
      return '+32';
    case 'FR':
      return '+33';
    case 'LU':
      return '+352';
    case 'CH':
      return '+41';
    case 'AT':
      return '+43';
    case 'ES':
      return '+34';
    case 'CZ':
      return '+420';
    case 'IT':
      return '+39';
    case 'DK':
      return '+45';
    case 'PL':
      return '+48';
    case 'LI':
      return '+423';
    case 'CY':
      return '+357';
    case 'SK':
      return '+421';
    case 'BG':
      return '+359';
    case 'IE':
      return '+353';
    case 'LV':
      return '+371';
    case 'MT':
      return '+356';
    case 'NO':
      return '+47';
    case 'PT':
      return '+351';
    case 'FI':
      return '+358';
    case 'HU':
      return '+36';
    case 'SI':
      return '+386';
    case 'RO':
      return '+40';
    case 'SE':
      return '+46';
    case 'HR':
      return '+385';
    case 'EE':
      return '+372';
    case 'GR':
      return '+30';
    case 'IS':
      return '+354';
    case 'LT':
      return '+370';
    case 'UK':
    case 'GB':
      return '+44';
    default:
      return '';
  }
};

export interface PhoneData {
  dialCode: string;
}

// NOTE: update the same function in `packages/e2e-tests/tests/web/phoneValidation.spec.ts` if you change this, until getaway-data-layer is linked to tests package
export const processPhoneNumber = (value: string, data: PhoneData): string => {
  if (!data?.dialCode) {
    return value;
  }

  // Remove existing dial code from the beginning if present
  let newVal = value.startsWith(data.dialCode)
    ? value.slice(data.dialCode.length)
    : value;

  // Remove leading zeros
  const zeroRegex = new RegExp(`^[0]*`, 'gi');
  newVal = newVal.replace(zeroRegex, '');

  // Ensure no dial code remnants in the number part
  const dialCodeRegex = new RegExp(`^${data.dialCode}`, 'gi');
  newVal = newVal.replace(dialCodeRegex, '');

  // Construct the final phone number with proper dial code
  return `+${data.dialCode}${newVal}`;
};

// NOTE: update the same function in `packages/e2e-tests/tests/web/phoneValidation.spec.ts` if you change this, until getaway-data-layer is linked to tests package
export const extractNationalNumber = (
  phoneNumber: string,
  dialCode: string
): string => {
  if (!phoneNumber || !dialCode) {
    return '';
  }

  // Remove the dial code and the '+' sign
  return phoneNumber.slice(dialCode.length + 1);
};

// NOTE: update the same function in `packages/e2e-tests/tests/web/phoneValidation.spec.ts` if you change this, until getaway-data-layer is linked to tests package
export const phoneNumberConstraint = () => ({
  phoneNumber: {
    presence: true,
    format: {
      pattern: /^[1-9][0-9]{6,14}$/,
      message(value: string) {
        if (value.length === 0) {
          return 'Bitte ausfüllen.';
        }
        return 'Bitte überprüfe deine Eingabe';
      },
    },
  },
});

export const CONSTRAINTS = {
  PHONE_NUMBER: phoneNumberConstraint,
};

// NOTE: update the same function in `packages/e2e-tests/tests/web/phoneValidation.spec.ts` if you change this, until getaway-data-layer is linked to tests package
export const validatePhoneNumber = (phoneNumber: string) => {
  const result = validate({ phoneNumber }, CONSTRAINTS.PHONE_NUMBER(), {
    fullMessages: false,
  });
  if (result && result.phoneNumber && result.phoneNumber.length) {
    return result.phoneNumber[0];
  }
  return '';
};
